import { render, staticRenderFns } from "./SsrSousRegion.vue?vue&type=template&id=02e0a848&"
import script from "./SsrSousRegion.vue?vue&type=script&lang=js&"
export * from "./SsrSousRegion.vue?vue&type=script&lang=js&"
import style0 from "./SsrSousRegion.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports